import { MotionConfig } from 'framer-motion';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ScrollProgress from './components/layout/ScrollProgress';
import HeroSection from './components/sections/HeroSection';
import AboutSection from './components/sections/AboutSection';
import ServicesSection from './components/sections/ServicesSection';
import ProjectsSection from './components/sections/ProjectsSection';
import GallerySection from './components/sections/GallerySection';
import ContactSection from './components/sections/ContactSection';
import { LanguageProvider } from './components/context/LanguageContext';
import './styles/globals.css';

function App() {
  return (
    <LanguageProvider>
      {/* Respeta la opción "reducir movimiento" del sistema: sin desplazamientos animados */}
      <MotionConfig reducedMotion="user">
        <div className="app">
          <ScrollProgress />
          <Navbar />
          <main>
            <HeroSection id="inicio" />
            <ServicesSection id="servicios" />
            <AboutSection id="quienes-somos" />
            <ProjectsSection id="proyectos" />
            <GallerySection id="galeria" />
            <ContactSection id="contacto" />
          </main>
          <Footer />
        </div>
      </MotionConfig>
    </LanguageProvider>
  );
}

export default App;
